import React from "react";
import { AuditCta } from "@/components/AuditCta";

const STOPS = ["New enquiry", "Instant reply", "Follow-up", "Meeting booked", "CRM updated"];

const Stop = ({ label, index }) => (
  <div className="relative flex md:flex-col items-center md:items-center gap-3 md:gap-0" data-testid={`hero-stop-${index + 1}`}>
    <span className="w-3 h-3 rounded-full border-2 border-[#3D472D] bg-[#F4E9D8] md:mb-4 shrink-0" />
    <span className="text-xs sm:text-sm font-semibold text-[#4A463F] md:text-center md:max-w-[120px]">{label}</span>
  </div>
);

export const HomeHero = () => (
  <section className="px-6 sm:px-8 pt-20 sm:pt-28 pb-20 sm:pb-28" data-testid="home-hero">
    <div className="max-w-4xl mx-auto text-center">
      <p className="font-semibold text-xs uppercase tracking-[0.22em] text-[#C8703A]" data-testid="hero-label">
        AI sales workflows, Singapore
      </p>
      <h1
        className="mt-8 font-fraunces font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-tight text-[#1F1F1C]"
        data-testid="hero-headline"
      >
        Your sales process, automated.
      </h1>
      <p className="mt-8 text-base md:text-lg text-[#4A463F] leading-relaxed max-w-2xl mx-auto" data-testid="hero-subline">
        We find where leads slip through, then build AI workflows that reply, follow up and book meetings for you. Using the tools you already have.
      </p>
      <div className="mt-11 flex justify-center">
        <AuditCta testId="hero-cta" />
      </div>
    </div>

    <div className="max-w-5xl mx-auto mt-20 sm:mt-28" data-testid="hero-workflow-line">
      {/* Desktop: horizontal line with a dot walking between stops */}
      <div className="hidden md:block relative">
        <div className="absolute left-[10%] right-[10%] top-[5px] h-px bg-[#3D472D]/35" aria-hidden="true" />
        <div className="absolute left-[10%] right-[10%] top-[5px] h-px z-10" aria-hidden="true">
          <span className="travel-x absolute -top-[4px] -ml-[4px] w-2.5 h-2.5 rounded-full bg-[#C8703A]" />
        </div>
        <div className="relative grid grid-cols-5">
          {STOPS.map((s, i) => (
            <Stop key={s} label={s} index={i} />
          ))}
        </div>
      </div>

      {/* Mobile: the same walk, vertical */}
      <div className="md:hidden relative pl-1">
        <div className="absolute left-[6px] top-[10px] bottom-[10px] w-px bg-[#3D472D]/35" aria-hidden="true" />
        <div className="absolute left-[6px] top-[10px] bottom-[10px] w-px z-10" aria-hidden="true">
          <span className="travel-y absolute -left-[4px] -mt-[4px] w-2.5 h-2.5 rounded-full bg-[#C8703A]" />
        </div>
        <div className="relative flex flex-col gap-7">
          {STOPS.map((s, i) => (
            <Stop key={s} label={s} index={i} />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HomeHero;
